// SERVER URL & STORAGE
export const BASE_URL = "https://apollo-epg.tibo.tv";
export const BASE_ASSETS_URL = "https://pub-75195737f2804b38bf798005e13b4f66.r2.dev";

// ENDPOINTS - auth
export const SIGN_IN = "/api/v1/auth/signin";
export const SIGN_UP = "/api/v1/auth/signup";
export const FORGET_PASSWORD = "/api/v1/auth/forgot-password";
export const USER_LOGGED_IN = "/api/v1/auth/me";
export const LOGOUT = "/api/v1/auth/logout";